<admin-app-header></admin-app-header>
<div class="container-fluid py-4">
    <div class="row align-items-center mb-3">
        <div class="col-8">
            <h2 class="mb-1">Blog</h2>
            <p class="text-muted mb-0">Articles shown on the public /news page and home page.</p>
        </div>
        <div class="col-4 text-end">
            <a [routerLink]="['/admin/cms/blogs/create']" class="btn btn-primary">
                <i class="fa-solid fa-plus me-1"></i> New blog article
            </a>
        </div>
    </div>
    <div class="content col-lg-12">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th scope="col">Created</th>
                <th scope="col">Title</th>
                <th scope="col">Status</th>
                <th scope="col">Link</th>
                <th scope="col">Functions</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let blog of blogs">
                <td>
                    {{ blog.createdAt | daysAgo }}
                </td>
                <td>
                    <a [routerLink]="['/admin/cms/blogs/', blog.$key]">
                        {{ blog.title || 'No Title' }}
                    </a>
                </td>
                <td>
                    <span class="badge" [class.bg-success]="blog.published !== false" [class.bg-secondary]="blog.published === false">
                        {{ blog.published === false ? 'Draft' : 'Published' }}
                    </span>
                </td>
                <td>
                    {{ blog.link || '' }}
                </td>
                <td>
                    <i (click)="deleteBlog(blog)" class="fa fa-trash text-danger"></i>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
